// extracted by mini-css-extract-plugin
module.exports = {"actionButtonWrapper":"Buttons_actionButtonWrapper__3zJgC","acceptButton":"Buttons_acceptButton__1hq_N","declineButton":"Buttons_declineButton___seUW"};